import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificacionInput } from 'src/app/models/notificacion/notificacion.models';

@Component({
    selector: 'app-notification-inbox',
    templateUrl: './notification-inbox.component.html',
    styleUrls: ['./notification-inbox.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(100%)' }),
                animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(100%)' })),
            ]),
        ]),
    ]
})

export class NotificationInboxComponent {
  @Input() data: NotificacionInput;
  @Input() fecha: Date;
  @Output() closed = new EventEmitter<void>();

  public close() {
    this.closed.emit();
  }

  public getTimeAgo(fecha: Date): string {
    const diffMs = new Date().getTime() - new Date(fecha).getTime();
    const diffSec = Math.floor(diffMs / 1000);
    if (diffSec < 60) return 'Hace unos segundos';
    if (diffSec < 3600) return `Hace ${Math.floor(diffSec / 60)} min`;
    return `Hace ${Math.floor(diffSec / 3600)} h`;
  }
}
